export default __webpack_public_path__ + "static/media/crowdfund.1aee1724.svg";